import React, { useCallback, useState, useEffect } from 'react';
import { Token } from 'src/common/api/use-integrations.hook';
import GooglePicker from 'src/integrations/GooglePicker';
import { GoogleDriveIntegrationIcon } from 'src/monet/icons';
import injectScript from 'src/utils/document/inject-script';
import { NeueButtonBase } from '../components/neue-button/base';
import { NeueJourneyButton } from '../components/neue-button/journey';

interface IntegrationGooglePickerButtonProps {
  token: Token;
  onFileSelected: (embedUrl: string, name: string) => void;
};

export const IntegrationMicrosoftOneDrivePickerButton: React.FC<IntegrationGooglePickerButtonProps> = ({
  token,
  onFileSelected,
  children,
}) => {
  const [pickerLoaded, setPickerLoaded] = useState(false);

  useEffect(() => {
    injectScript("https://js.live.net/v7.2/OneDrive.js").then(() => {
      setPickerLoaded(true);
    })
  }, []);

  const launchPicker = useCallback(() => {
    const odOptions = {
      clientId: "2f4c4d35-885d-49b5-ac97-a06f8d80d11a",
      action: "download",
      multiSelect: false,
      openInNewWindow: true,
      success: (files: any) => {
        const file = files.value[0];
        const embedUrl = file["@microsoft.graph.downloadUrl"];
        const name = file.name;
        onFileSelected(embedUrl, name);
      },
      advanced: {
        accessToken: token.access_token,
      },
      cancel: () => {},
      error: (e: any) => {
        console.error(e);
      }
    };

    (window as any).OneDrive.open(odOptions);
  }, [pickerLoaded, onFileSelected]);

  return (
    <NeueButtonBase
      className={'py-[9px] px-4 text-neue-journey-fg w-full'}
      baseColor={'rgb(var(--neue-journey-fg-10))'}
      gradientMaxOpacity={0.1}
      onClick={launchPicker}
    >
      <div className="flex flex-1 items-center space-x-2">
        <div>Pick from One Drive</div>
      </div>
    </NeueButtonBase>
  )
}